import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import ru from "./ru.json";
import en from "./en.json";
import de from "./de.json";
import uk from "./uk.json";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: en,
  },
  ru: {
    translation: ru,
  },
  de: {
    translation: de,
  },
  uk: {
    translation: uk,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "de", "uk", "ru"],
    defaultNS: "translation",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
